module.exports = __webpack_public_path__ + "img/icon.53186eee.svg";